// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Popup_Container {
    position: absolute;
    aspect-ratio: 16/9;
    max-width: 177.778vh;
    max-height: 56.25vw;
    width: 100%;

    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;

    z-index: 101;

    container-type: size;
}

#Popup_Container img {
    position: absolute;
    left: 50%;
    top: 25.5%;

    transform: translate(-50%);

    width: 46.77%;

    z-index: inherit;
}

#Popup_Container button {
    position: absolute;
    top: 53%;

    width: 12.11%;
    height: 3.4259%;

    border-radius: 0%;

    background-color: #747474;
    border: none;

    color: white;
    
    font: 2cqmin MyriadPro-Regular;
    line-height: 1cqmin;

    z-index: inherit;
}

#Popup_Container button:hover {
    color: goldenrod;
    background-color: #6b6b6b;
    border: 1px solid goldenrod;
}

#Popup_Container button:focus {
    color: goldenrod;
    background-color: #6b6b6b;
    border: 1px solid goldenrod;
}

#Popup_RefreshBtn {
    left: 50%;
    transform: translate(-50%);
}

#Popup_CloseBtn {
    left: 58%;
}

#Popup_Header {
    position: absolute;

    left: 33%;
    top: 31%;

    width: 35%;

    padding: 0;
    margin: 0;

    z-index: inherit;
    color: white;
    font: 3.2cqmin MyriadPro-Regular;
    line-height: 3cqmin;
}

#Popup_Body {
    position: absolute;

    left: 33%;
    top: 43.5%;

    width: 35%;

    transform: translate(0, -50%);

    padding: 0;
    margin: 0;

    z-index: inherit;
    color: white;
    font: 2.8cqmin MyriadPro-Regular;
    line-height: 3cqmin;
}
`, "",{"version":3,"sources":["webpack://./src/components/PopupMessage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;;IAEX,gCAAgC;IAChC,QAAQ;IACR,SAAS;;IAET,YAAY;;IAEZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;;IAEV,0BAA0B;;IAE1B,aAAa;;IAEb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;;IAER,aAAa;IACb,eAAe;;IAEf,iBAAiB;;IAEjB,yBAAyB;IACzB,YAAY;;IAEZ,YAAY;;IAEZ,8BAA8B;IAC9B,mBAAmB;;IAEnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,QAAQ;;IAER,UAAU;;IAEV,UAAU;IACV,SAAS;;IAET,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,UAAU;;IAEV,UAAU;;IAEV,6BAA6B;;IAE7B,UAAU;IACV,SAAS;;IAET,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;AACvB","sourcesContent":["#Popup_Container {\r\n    position: absolute;\r\n    aspect-ratio: 16/9;\r\n    max-width: 177.778vh;\r\n    max-height: 56.25vw;\r\n    width: 100%;\r\n\r\n    transform: translate(-50%, -50%);\r\n    top: 50%;\r\n    left: 50%;\r\n\r\n    z-index: 101;\r\n\r\n    container-type: size;\r\n}\r\n\r\n#Popup_Container img {\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 25.5%;\r\n\r\n    transform: translate(-50%);\r\n\r\n    width: 46.77%;\r\n\r\n    z-index: inherit;\r\n}\r\n\r\n#Popup_Container button {\r\n    position: absolute;\r\n    top: 53%;\r\n\r\n    width: 12.11%;\r\n    height: 3.4259%;\r\n\r\n    border-radius: 0%;\r\n\r\n    background-color: #747474;\r\n    border: none;\r\n\r\n    color: white;\r\n    \r\n    font: 2cqmin MyriadPro-Regular;\r\n    line-height: 1cqmin;\r\n\r\n    z-index: inherit;\r\n}\r\n\r\n#Popup_Container button:hover {\r\n    color: goldenrod;\r\n    background-color: #6b6b6b;\r\n    border: 1px solid goldenrod;\r\n}\r\n\r\n#Popup_Container button:focus {\r\n    color: goldenrod;\r\n    background-color: #6b6b6b;\r\n    border: 1px solid goldenrod;\r\n}\r\n\r\n#Popup_RefreshBtn {\r\n    left: 50%;\r\n    transform: translate(-50%);\r\n}\r\n\r\n#Popup_CloseBtn {\r\n    left: 58%;\r\n}\r\n\r\n#Popup_Header {\r\n    position: absolute;\r\n\r\n    left: 33%;\r\n    top: 31%;\r\n\r\n    width: 35%;\r\n\r\n    padding: 0;\r\n    margin: 0;\r\n\r\n    z-index: inherit;\r\n    color: white;\r\n    font: 3.2cqmin MyriadPro-Regular;\r\n    line-height: 3cqmin;\r\n}\r\n\r\n#Popup_Body {\r\n    position: absolute;\r\n\r\n    left: 33%;\r\n    top: 43.5%;\r\n\r\n    width: 35%;\r\n\r\n    transform: translate(0, -50%);\r\n\r\n    padding: 0;\r\n    margin: 0;\r\n\r\n    z-index: inherit;\r\n    color: white;\r\n    font: 2.8cqmin MyriadPro-Regular;\r\n    line-height: 3cqmin;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
